// /opt/isp_erp/frontend/src/components/warehouse/AsignarTecnicoSucursalDialog.jsx
import React, { useState, useEffect } from "react";
import { Typography, TextField, MenuItem, Alert, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import axios from "../../api/axios";
import { mensajeError } from "../../utils/mensajesError";

/** Asigna un equipo o una viñeta del inventario de una sucursal a uno de los técnicos de esa sucursal. tipo: "equipo" | "vineta" */
export default function AsignarTecnicoSucursalDialog({ sucursalId, tipo, item, onClose, onHecho }) {
  const [tecnicos, setTecnicos] = useState([]);
  const [tecnicoId, setTecnicoId] = useState("");
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);
  const esEquipo = tipo === "equipo";

  useEffect(() => {
    axios.get(`/warehouse/sucursales/${sucursalId}/personal`)
      .then((r) => setTecnicos((r.data || []).filter((p) => p.rol === "TECNICO")))
      .catch(() => setTecnicos([]));
  }, [sucursalId]);

  const guardar = async () => {
    setError("");
    if (!tecnicoId) { setError("Elige el técnico"); return; }
    setEnviando(true);
    try {
      const base = `/warehouse/sucursales-equipos/${sucursalId}`;
      const r = esEquipo
        ? await axios.post(`${base}/asignar-equipo`, { sn: item.sn, tecnico_id: Number(tecnicoId) })
        : await axios.post(`${base}/asignar-vineta`, { vignette_id: item.id, tecnico_id: Number(tecnicoId) });
      onHecho(r.data.mensaje);
    } catch (e) {
      setError(mensajeError(e, "No se pudo asignar"));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open onClose={enviando ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>Asignar a un técnico</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {esEquipo ? `${item.sn} · ${item.modelo || ""}` : `${item.serial} · ${item.nombre || ""}`}
        </Typography>
        {tecnicos.length === 0 && (
          <Alert severity="info" sx={{ mb: 2 }}>Esta sucursal no tiene técnicos. Agrégalos en Sucursales → Personal.</Alert>
        )}
        <TextField select fullWidth size="small" label="Técnico" value={tecnicoId} onChange={(e) => setTecnicoId(e.target.value)}>
          {tecnicos.map((t) => (<MenuItem key={t.user_id} value={t.user_id}>{t.username}</MenuItem>))}
        </TextField>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={enviando}>Cancelar</Button>
        <Button variant="contained" onClick={guardar} disabled={enviando}>{enviando ? "Guardando..." : "Asignar"}</Button>
      </DialogActions>
    </Dialog>
  );
}
